export default defineAppConfig({
  ui: {
    colors: {
      neutral: 'zinc',
      primary: 'flame',
      secondary: 'teal',
    },
    icons: {
      arrowDown: 'mdi:arrow-down',
      arrowLeft: 'mdi:arrow-left',
      arrowRight: 'mdi:arrow-right',
      arrowUp: 'mdi:arrow-up',
      caution: 'mdi:alert-circle',
      check: 'mdi:check',
      chevronDoubleLeft: 'mdi:chevron-double-left',
      chevronDoubleRight: 'mdi:chevron-double-right',
      chevronDown: 'mdi:chevron-down',
      chevronLeft: 'mdi:chevron-left',
      chevronRight: 'mdi:chevron-right',
      chevronUp: 'mdi:chevron-up',
      close: 'mdi:close',
      copy: 'mdi:content-copy',
      copyCheck: 'mdi:check-all',
      dark: 'mdi:weather-night',
      drag: 'mdi:drag-vertical',
      ellipsis: 'mdi:dots-horizontal',
      error: 'mdi:close-circle',
      external: 'mdi:open-in-new',
      eye: 'mdi:eye',
      eyeOff: 'mdi:eye-off',
      file: 'mdi:file',
      folder: 'mdi:folder',
      folderOpen: 'mdi:folder-open',
      hash: 'mdi:pound',
      info: 'mdi:information',
      light: 'mdi:weather-sunny',
      loading: 'mdi:loading',
      menu: 'mdi:menu',
      minus: 'mdi:minus',
      panelClose: 'mdi:arrow-collapse-left',
      panelOpen: 'mdi:arrow-expand-right',
      plus: 'mdi:plus',
      reload: 'mdi:reload',
      search: 'mdi:magnify',
      stop: 'mdi:stop',
      success: 'mdi:check-circle',
      system: 'mdi:monitor',
      tip: 'mdi:lightbulb',
      upload: 'mdi:upload',
      warning: 'mdi:alert',
    },
  },
})
